import { useState, type ReactNode } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface KpiSectionProps {
    title: string;
    subtitle: string;
    icon: ReactNode;
    color: string;
    defaultOpen?: boolean;
    children: ReactNode;
}

export const KpiSection = ({ title, subtitle, icon, color, defaultOpen = false, children }: KpiSectionProps) => {
    const [isCollapsed, setIsCollapsed] = useState(!defaultOpen);

    return (
        <div className="bg-surface-container-lowest rounded-xl shadow-sm overflow-hidden">
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="w-full flex items-center justify-between px-6 py-4 cursor-pointer bg-surface-container-high hover:bg-[#e2dede] transition-colors"
                style={{ borderBottom: isCollapsed ? "none" : "1px solid rgba(199,197,214,0.3)" }}
            >
                <div className="flex items-center gap-3">
                    <div className="p-2 rounded-md text-white flex-shrink-0" style={{ backgroundColor: color }}>
                        {icon}
                    </div>
                    <div className="text-left">
                        <h2 className="font-headline font-black text-[10px] uppercase tracking-widest section-title">{title}</h2>
                        <p className="text-sm font-medium text-on-surface-variant">{subtitle}</p>
                    </div>
                </div>
                {isCollapsed ? (
                    <ChevronDown className="w-5 h-5 text-on-surface-variant" />
                ) : (
                    <ChevronUp className="w-5 h-5 text-on-surface-variant" />
                )}
            </button>
            {!isCollapsed && <div className="p-6 space-y-6">{children}</div>}
        </div>
    );
};
